import React, { ReactNode } from 'react';
import { Card, Table } from 'react-bootstrap';
import { Column, useTable } from 'react-table';

import { useWhyDidYouUpdate } from '../../hooks';

type Props<D extends object = {}> = {
  readonly title?: string;
  //columns: Array<Column<D>>;
  readonly columns: ReadonlyArray<Column<any>>;
  readonly data: readonly any[];
  readonly showButtonRedEye?: boolean;
  readonly invalid?: boolean;
  readonly rowProps?: (row) => object;
  readonly onRefresh?: () => void;
  readonly onSelectRow?: (any) => void;
  readonly onCreate?: () => void;
  readonly children?: ReactNode;
  readonly style?: any;
  readonly id?: any;
};

function TableSubSimple<D extends object = {}>({
  title,
  columns,
  data,
  showButtonRedEye = true,
  invalid = false,
  rowProps = null,
  onRefresh = null,
  onSelectRow = null,
  onCreate = null,
  children = null,
  style,
  id = null,
}: Props<D>) {
  //
  //-------------------- Body -----------------------------------------------
  //
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable({
      columns,
      data,
    });

  //
  //-------------------- Render ----------------------------------------------
  //
  useWhyDidYouUpdate('[TableSubSimple]', { columns, data });
  return (
    <Card.Body className="p-0" id={id}>
      <Table
        striped
        hover
        bordered
        {...getTableProps()}
        className="mb-0"
        style={style}
      >
        <thead className="thead-dark">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} className="text-center">
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} className="align-middle">
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps((rowProps && rowProps(row)) || {})}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        {/* <tfoot style={{ backgroundColor: '#e1f3f7' }}>
            {footerGroups.map(footerGroup => (
              <tr {...footerGroup.getFooterGroupProps()} className="text-center">
                {footerGroup.headers.map(column => (
                  <td {...column.getFooterProps()}>{column.render('Footer')}</td>
                ))}
              </tr>
            ))}
          </tfoot> */}
      </Table>
      {children}
    </Card.Body>
  );
}

export default React.memo(TableSubSimple);

